import React from "react";
import dynamic from "next/dynamic";
import { WaitForConfig } from "../../components/WaitForConfig";
import { OVERLAY_TYPE } from "../../hooks/useOverlaySettings";
import theme from "../../theme";
import { ChakraProvider } from "@chakra-ui/react";

export function getStaticProps() {
  return {
    props: {
      customOverlay: true,
    },
  };
}

// Need to dynamic import this because Alert Page need Audio that cant work on SSR
const Alert = dynamic(() => import("../../PagesComponent/_alert"), {
  ssr: false,
});

const CustomAlert = dynamic(() => import("../../PagesComponent/_customAlert"), {
  ssr: false,
});

const Inner = ({ isSimple, ...props }) => {
  if (isSimple) {
    return (
      <ChakraProvider theme={theme}>
        <Alert {...props} />
      </ChakraProvider>
    );
  }

  return <CustomAlert {...props} />;
};

const AlertWidget = () => {
  return <WaitForConfig Component={Inner} overlayType={OVERLAY_TYPE.ALERT} />;
};

export default AlertWidget;
